/*
 * KAYA reviews — Worker submission (coexists with kaya-reviews.js).
 * If the section has data-review-endpoint set, intercept the review form submit,
 * POST it (incl. the media file) to the Cloudflare Worker as multipart/form-data,
 * and show a thank-you. With no endpoint set, do nothing — the native contact-form
 * fallback in kaya-reviews.js handles it. Field names match worker.js.
 */
(function () {
  'use strict';

  function init(root) {
    if (root.__kayaRvSubmitInit) return;
    root.__kayaRvSubmitInit = true;

    var endpoint = (root.getAttribute('data-review-endpoint') || '').trim();
    if (!endpoint) return; // native fallback owns submit

    var productId = (root.getAttribute('data-product-id') || '').trim();
    var form = document.getElementById('kaya-review-form');
    var modal = root.querySelector('[data-kaya-rv-modal]');
    if (!form || !modal) return;

    var ratingInput = root.querySelector('[data-kaya-rv-rating-input]');
    var ratingHint = root.querySelector('[data-kaya-rv-rating-hint]');
    var mediaInput = root.querySelector('[data-kaya-rv-media-input]');
    var submitBtn = root.querySelector('[data-kaya-rv-submit]');
    var dialog = root.querySelector('.kaya-rv-modal__dialog');

    function field(id) {
      var el = document.getElementById(id);
      return el ? el.value.trim() : '';
    }

    function showThanks() {
      form.style.display = 'none';
      var t = document.createElement('div');
      t.className = 'kaya-rv-modal__thanks';
      t.innerHTML =
        '<span class="kaya-rv-modal__thanks-mark"><svg viewBox="0 0 48 48" width="44" height="44" aria-hidden="true">' +
        '<circle cx="24" cy="24" r="23" fill="none" stroke="#272727" stroke-width="1.5"/>' +
        '<path d="M16 24.5l5.5 5.5L33 18.5" fill="none" stroke="#272727" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg></span>' +
        '<h3 class="kaya-rv-modal__title">Thank you for your review</h3>' +
        '<p class="kaya-rv-modal__thanks-text">It’s been sent to our team and will appear here once approved.</p>' +
        '<button type="button" class="kaya-rv-modal__submit" data-kaya-rv-close>Done</button>';
      dialog.appendChild(t);
      var done = t.querySelector('[data-kaya-rv-close]');
      if (done) done.addEventListener('click', function () {
        modal.hidden = true;
        document.documentElement.style.overflow = '';
      });
    }

    function showError(msg) {
      var existing = dialog.querySelector('[data-kaya-rv-submit-error]');
      if (!existing) {
        existing = document.createElement('p');
        existing.className = 'kaya-rv-modal__error';
        existing.setAttribute('data-kaya-rv-submit-error', '');
        existing.setAttribute('role', 'alert');
        form.insertBefore(existing, form.firstChild);
      }
      existing.textContent = msg || 'Something went wrong — please try again.';
    }

    form.addEventListener('submit', function (e) {
      // Endpoint is set → this path owns the submit; never let the native form post.
      e.preventDefault();

      if (ratingInput && !ratingInput.value) {
        if (ratingHint) ratingHint.hidden = false;
        return;
      }
      if (submitBtn && submitBtn.dataset.busy === '1') return;

      var fd = new FormData();
      fd.append('rating', ratingInput ? ratingInput.value : '');
      fd.append('title', field('kaya-rv-title'));
      fd.append('body', field('kaya-rv-body'));
      fd.append('author', field('kaya-rv-name'));
      fd.append('email', field('kaya-rv-email'));
      fd.append('product_id', productId);
      if (mediaInput && mediaInput.files && mediaInput.files[0]) {
        fd.append('media', mediaInput.files[0]);
      }

      var restore = '';
      if (submitBtn) {
        submitBtn.dataset.busy = '1';
        submitBtn.disabled = true;
        restore = submitBtn.textContent;
        submitBtn.textContent = 'Submitting…';
      }

      fetch(endpoint, { method: 'POST', body: fd })
        .then(function (r) { return r.json().catch(function () { return { ok: r.ok }; }); })
        .then(function (data) {
          if (data && data.ok) {
            showThanks();
          } else {
            showError((data && data.error) ? 'Could not submit (' + data.error + ').' : 'Submission failed.');
            if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = restore; delete submitBtn.dataset.busy; }
          }
        })
        .catch(function () {
          showError('Network error — please try again.');
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = restore; delete submitBtn.dataset.busy; }
        });
    });
  }

  function boot() {
    document.querySelectorAll('[data-kaya-reviews]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
